import FormControl from "@mui/material/FormControl/FormControl";
import FormGroup from "@mui/material/FormGroup";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import AppState from "../../AppState";
import { IFilterForm } from "../../AppState/overagesFilterFormActions";
import { saveExceptionSearchFilterForm } from "../../AppState/exceptionSearchFilterFromAction";

const SearchWithBarcode: React.FC = () => {
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const filterForm: IFilterForm = useSelector(
    (state: AppState) => state.exceptionSearchFilterForm
  );

  const clearingStatus = filterForm.visibility?.length ? filterForm.visibility[0] : "nonCleared";

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const handleClearingStatusChange = (e: SelectChangeEvent) => {
    const filterFormParam: IFilterForm = { ...filterForm, visibility: [e.target.value] };
    dispatch(saveExceptionSearchFilterForm(filterFormParam));
  };

  const handleSearch = () => {
    const searchStr = searchValue.trim();
    if (!searchStr) return;
    const filterFormParam: IFilterForm = { ...filterForm, search: searchStr, visibility: [clearingStatus] };
    dispatch(saveExceptionSearchFilterForm(filterFormParam));
    navigate(`/exceptions/search`);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <FormGroup className="flex-update">
      <FormGroup row sx={{ gap: 1 }} style={{ width: "calc(100% - 110px)", position: "relative" }}>
        <FormControl className="search-input">
          <TextField
            autoComplete="off"
            style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
            placeholder="Search with exception details"
            id="outlined-start-adornment"
            variant="outlined"
            size="medium"
            fullWidth
            value={searchValue}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            InputProps={{
              inputProps: {
                maxLength: 50,
              },
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </FormControl>
        <FormControl className="search-dropdown" size="medium" sx={{ minWidth: 120 }} style={{ position: "absolute", right: 0, top: 0 }}>
          <Select
            value={clearingStatus}
            onChange={handleClearingStatusChange}
            displayEmpty
            IconComponent={() => null}
            sx={{ fontSize: "13px" }}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  size="small"
                  sx={{ pointerEvents: "none" }}
                >
                  <KeyboardArrowDownIcon sx={{ color: "#0BADC5" }} />
                </IconButton>
              </InputAdornment>
            }
          >
            <MenuItem value="nonCleared" sx={{ fontSize: "13px", borderLeft: "3px solid #FFC051", lineHeight: "33px", "&.Mui-selected": { color: "#0BADC5" } }}>Open</MenuItem>
            <MenuItem value="cleared" sx={{ fontSize: "13px", borderLeft: "3px solid #0BC568", lineHeight: "33px", "&.Mui-selected": { color: "#0BADC5" } }}>Cleared</MenuItem>
          </Select>
        </FormControl>
      </FormGroup>
      <FormGroup>
        <Button
          variant="contained"
          className="search-btn search-effect"
          disableElevation
          onClick={handleSearch}
        >
          Search
        </Button>
      </FormGroup>
    </FormGroup>
  );
};

export default SearchWithBarcode;
